var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:{mobile:_vm.isMobile}},[_vm._v(_vm._s(_vm.label)+" "),(_vm.required)?_c('span',{staticClass:"span",staticStyle:{"color":"red"}},[_vm._v("*")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }